<template>
  <v-fade-transition>
    <div v-if="value" class="qr-internal-overlay" @click.self="close">
      <v-card class="qr-modal-card text-center pa-4 elevation-16" rounded="xl">
        <!-- دکمه بستن -->
        <v-btn icon small class="close-qr-btn" @click="close">
          <v-icon size="18" color="grey lighten-1">mdi-close</v-icon>
        </v-btn>

        <!-- آواتار / لوگو -->
        <v-avatar v-if="profileAvatar || icon"
          size="56" 
          class="elevation-3 mb-2 mt-2 qr-modal-avatar" 
          :style="{ borderColor: primaryColor }"
        >
          <img v-if="profileAvatar" :src="profileAvatar" alt="Logo" style="object-fit: cover;" />
          <v-icon v-else size="32" :color="primaryColor">{{ icon }}</v-icon>
        </v-avatar>

        <!-- عنوان اصلی -->
        <h3 class="text-subtitle-1 font-weight-black mb-1 text-truncate" style="color: #1e293b;">
          {{ title || "کیوآر" }}
        </h3>

        <!-- متن راهنما -->
        <p class="text-caption text--secondary mb-3 px-2" style="font-size: 11px !important; line-height: 1.5;">
          {{ subtitle || "برای مشاهده اطلاعات کیوآر کد را اسکن کنید" }}
        </p>

        <!-- کادر QR کد -->
        <div class="qr-image-box pa-2 mb-2 elevation-1">
          <img 
            v-if="effectiveQrImage" 
            :src="effectiveQrImage" 
            alt="QR Code" 
            class="qr-img" 
          />
          <v-skeleton-loader v-else type="image" width="140" height="140" />
        </div>

        <!-- شناسه و آدرس اختصاصی -->
        <div v-if="identifier" class="qr-target-id mb-3">
          <v-icon x-small :color="primaryColor" class="mr-1">mdi-link-variant</v-icon>
          <span class="caption font-weight-bold">qrland.ir/{{ cleanIdentifier }}</span>
        </div>

        <!-- کادر گزینه‌های اشتراک‌گذاری افقی اسکرول‌شونده -->
        <div class="share-box-frame mb-3">
          <div 
            class="share-options-container"
            ref="shareContainer"
            :class="{ 'dragging': isDragging }"
            @mousedown="startDrag"
            @mouseleave="stopDrag"
            @mouseup="stopDrag"
            @mousemove="onDrag"
          >
            <div 
              v-for="(item, index) in shareItems" 
              :key="index" 
              class="share-item"
              @click="handleShareAction(item.action)"
            >
              <div class="share-icon-wrapper">
                <img :src="item.icon" :alt="item.label" class="share-icon" />
              </div>
              <span class="share-label">{{ item.label }}</span>
            </div>
          </div>
        </div>

        <!-- دکمه دانلود کیوآرکد -->
        <v-btn
          block
          large
          :color="primaryColor"
          dark
          rounded
          depressed
          class="download-btn font-weight-bold"
          @click="downloadQrCode"
        >
          <v-icon left size="18" class="ml-1">mdi-download</v-icon>
          دانلود کیوآرکد
        </v-btn>
      </v-card>
    </div>
  </v-fade-transition>
</template>

<script>
export default {
  name: "UniversalQrModal",
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: "",
    },
    subtitle: {
      type: String,
      default: "",
    },
    identifier: {
      type: String,
      default: "",
    },
    profileAvatar: {
      type: String,
      default: "",
    },
    qrImageUrl: {
      type: String,
      default: "",
    },
    svgData: {
      type: String,
      default: "",
    },
    primaryColor: {
      type: String,
      default: "#1976D2",
    },
    customShareLink: {
      type: String,
      default: "",
    },
    icon:{
      type:String,
      default: null
    }
  },
  data() {
    return {
      isDragging: false,
      startX: 0,
      scrollLeft: 0,
      dragDistance: 0,
      shareItems: [
        { label: "کپی لینک", icon: "logos/copy.webp", action: "copy" },
        { label: "واتساپ", icon: "logos/1 (16).webp", action: "whatsapp" },
        { label: "تلگرام", icon: "logos/1 (98).svg", action: "telegram" },
        { label: "ایتا", icon: "logos/1 (17).webp", action: "eitaa" },
        { label: "روبیکا", icon: "logos/1 (8).webp", action: "rubika" },
        { label: "بله", icon: "logos/1 (24).webp", action: "bale" },
        { label: "سروش", icon: "logos/1 (12).webp", action: "soroush" },
        { label: "X", icon: "logos/1 (31).svg", action: "x" },
        { label: "فیسبوک", icon: "logos/1 (7).svg", action: "facebook" },
        { label: "ایمیل", icon: "logos/1 (14).webp", action: "email" },
        { label: "بیشتر", icon: "logos/more.webp", action: "more" },
      ],
    };
  },
  computed: {
    cleanIdentifier() {
      return (this.identifier || "").replace(/^@/, "").trim();
    },
    effectiveQrImage() {
      return this.svgData || this.qrImageUrl || "";
    },
    computedShareLink() {
      if (this.customShareLink) return this.customShareLink;
      return this.cleanIdentifier
        ? `https://qrland.ir/${this.cleanIdentifier}`
        : window.location.href;
    },
  },
  methods: {
    startDrag(e) {
      this.isDragging = true;
      this.dragDistance = 0;
      const container = this.$refs.shareContainer;
      this.startX = e.pageX - container.offsetLeft;
      this.scrollLeft = container.scrollLeft;
    },
    stopDrag() {
      this.isDragging = false;
    },
    onDrag(e) {
      if (!this.isDragging) return;
      e.preventDefault();
      const container = this.$refs.shareContainer;
      const x = e.pageX - container.offsetLeft;
      const walk = (x - this.startX) * 1.5;
      this.dragDistance = Math.abs(walk);
      container.scrollLeft = this.scrollLeft - walk;
    },
    close() {
      this.$emit("input", false);
    },
async handleShareAction(action) {
  if (this.dragDistance > 6) return;

  const url = encodeURIComponent(this.computedShareLink);
  const title = encodeURIComponent(this.title || "مشاهده کیوآر کد");
  const fullText = encodeURIComponent(`${this.title || "مشاهده کیوآر کد"}\n${this.computedShareLink}`);

  switch (action) {
    case "copy":
      try {
        await navigator.clipboard.writeText(this.computedShareLink);
        if (this.$toast) this.$toast.success("لینک با موفقیت کپی شد!");
      } catch (err) {
        // Fallback برای مرورگرهایی که دسترسی کلیپ‌بورد ندارند
        const input = document.createElement("input");
        input.value = this.computedShareLink;
        document.body.appendChild(input);
        input.select();
        document.execCommand("copy");
        document.body.removeChild(input);
        if (this.$toast) this.$toast.success("لینک با موفقیت کپی شد!");
      }
      break;

    case "whatsapp":
      window.open(`https://wa.me/?text=${fullText}`, "_blank");
      break;

    case "telegram":
      window.open(`https://t.me/share/url?url=${url}&text=${title}`, "_blank");
      break;

    case "eitaa":
      window.open(`https://eitaa.com/share/url?url=${url}&text=${title}`, "_blank");
      break;

    case "bale":
      window.open(`https://ble.ir/share/url?url=${url}&text=${title}`, "_blank");
      break;

    case "rubika":
      window.open(`rubika://share?text=${fullText}`, "_blank");
      break;

    case "soroush":
      window.open(`https://splus.ir/share?url=${url}&text=${title}`, "_blank");
      break;

    case "x":
      window.open(`https://twitter.com/intent/tweet?url=${url}&text=${title}`, "_blank");
      break;

    case "facebook":
      window.open(`https://www.facebook.com/sharer/sharer.php?u=${url}&quote=${title}`, "_blank");
      break;

    case "email":
      window.location.href = `mailto:?subject=${title}&body=${fullText}`;
      break;

    case "more":
      if (navigator.share) {
        navigator.share({
          title: this.title || "مشاهده کیوآر کارت",
          text: this.subtitle || "",
          url: this.computedShareLink,
        }).catch(() => {});
      } else {
        this.handleShareAction("copy");
      }
      break;
  }
},
    async downloadQrCode() {
      const src = this.effectiveQrImage;
      if (!src) return;

      try {
        const a = document.createElement("a");
        const filename = `${this.cleanIdentifier || "QR"}.${src.includes("svg") ? "svg" : "png"}`;

        if (src.startsWith("data:")) {
          a.href = src;
          a.download = filename;
          document.body.appendChild(a);
          a.click();
          document.body.removeChild(a);
        } else {
          const response = await fetch(src);
          const blob = await response.blob();
          const blobUrl = window.URL.createObjectURL(blob);
          a.href = blobUrl;
          a.download = filename;
          document.body.appendChild(a);
          a.click();
          document.body.removeChild(a);
          window.URL.revokeObjectURL(blobUrl);
        }
      } catch (e) {
        console.error("خطا در دانلود کیوآر:", e);
      }
    },
  },
};
</script>

<style scoped>
.qr-internal-overlay {
  position: absolute;
  inset: 0;
  background: rgba(15, 23, 42, 0.65);
  backdrop-filter: blur(6px);
  z-index: 50;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px;
  border-radius: inherit;
}

.qr-modal-card {
  position: relative;
  background: #ffffff !important;
  color: #1e293b;
  width: 100%;
  max-width: 290px;
  border-radius: 24px !important;
  overflow: hidden;
}

.close-qr-btn {
  position: absolute;
  top: 10px;
  left: 10px;
}

.qr-modal-avatar {
  border: 3px solid;
  background: #ffffff;
}

.qr-image-box {
  background: #ffffff;
  border-radius: 16px;
  display: inline-block;
  border: 1px solid #f1f5f9;
}

.qr-img {
  width: 140px;
  height: 140px;
  display: block;
  object-fit: contain;
}

.qr-target-id {
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  padding: 4px 14px;
  border-radius: 20px;
  display: inline-flex;
  align-items: center;
  direction: ltr;
  color: #334155;
}

.share-box-frame {
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 16px;
  padding: 10px 4px;
  width: 100%;
}

.share-options-container {
  display: flex;
  overflow-x: auto;
  gap: 12px;
  padding: 4px 8px;
  direction: rtl;
  scrollbar-width: none;
  -ms-overflow-style: none;
  cursor: grab;
  user-select: none;
}
.share-options-container::-webkit-scrollbar {
  display: none;
}
.share-options-container.dragging {
  cursor: grabbing;
}

.share-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  cursor: pointer;
  min-width: 48px;
  transition: transform 0.2s ease;
}
.share-item:active {
  transform: scale(0.95);
}

.share-icon-wrapper {
  width: 42px;
  height: 42px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 6px;
}

.share-icon {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

.share-label {
  font-size: 10px;
  color: #475569;
  font-weight: 500;
  white-space: nowrap;
}

.download-btn {
  border-radius: 14px !important;
  font-size: 13px !important;
  letter-spacing: 0 !important;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.12) !important;
}
</style>
